// apiClient.js

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        document.cookie.split(";").forEach(cookie => {
            const trimmedCookie = cookie.trim();
            const separatorIndex = trimmedCookie.indexOf("=");
            const key = separatorIndex === -1 ? trimmedCookie : trimmedCookie.slice(0, separatorIndex);
            const val = separatorIndex === -1 ? "" : trimmedCookie.slice(separatorIndex + 1);
            if (key === name) {
                cookieValue = decodeURIComponent(val);
            }
        });
    }
    return cookieValue;
}

/**
 * A helper function for making API requests that automatically attaches
 * the access token from localStorage and sends CSRF protection for unsafe requests.
 *
 * @param {string} url - The API endpoint to call.
 * @param {object} options - Additional options for fetch (method, body, etc.).
 * @returns {Promise<Response>} - The fetch response.
 */
export async function apiFetch(url, options = {}) {
    const token = localStorage.getItem("access_token");
    const method = (options.method || "GET").toUpperCase();
    const headers = {
        ...(options.headers || {}),
    };

    if (!(options.body instanceof FormData) && !headers["Content-Type"]) {
        headers["Content-Type"] = "application/json";
    }

    if (token && !headers.Authorization) {
        headers.Authorization = `Bearer ${token}`;
    }

    if (!["GET", "HEAD", "OPTIONS", "TRACE"].includes(method) && !headers["X-CSRFToken"]) {
        const csrfToken = getCookie("csrftoken");
        if (csrfToken) {
            headers["X-CSRFToken"] = csrfToken;
        }
    }

    return await fetch(url, {
        credentials: "same-origin",
        ...options,
        method,
        headers,
    });
}
